import { createTheme } from '@mui/material';
import {
  BancalivColors,
  CredinverColors,
  CredipressColors,
  CreditooColors,
  FibancaColors,
  FieColors,
  ZaliColors,
  LibramonedaColors,
  FinnvoColors,
  FondoColors,
  FreendColors,
  GymColors,
  InversionesColors,
  LenddiColors,
  LiberateColors,
  MaxcreditColors,
  MiliColors2,
  NauwColors,
  SofiColors,
  TuSolucionColors,
  QuickBankColors,
  FinanzasColors,
  FembisolColors,
  CreceValorColors,
  SuValorColors,
  MifianzaColors,
  FinzapColors,
  ProcordColors,
  ResuelveYaColors,
  SocialCreditColors,
  CxCColors,
  BanviColors,
  HazloyaColors,
  PysColors,
  NetWifiColors,
  CredyfastColors,
  ValitColors,
  MeloncashColors,
  OportunidadesColors,
  TrufiColors,
  FinanzColors,
  LogicashColors,
  KrennovaColors,
} from './colors';
import { selectClientName } from '../utils';

const selectTheme = () => {
  const selectedTheme = selectClientName();
  switch (selectedTheme) {
    case 'local':
      return MiliColors2;
    case 'finzap':
      return FinzapColors;
    case 'meloncash':
      return MeloncashColors;
    case 'oportunidades':
      return OportunidadesColors;
    case 'resuelveya':
      return ResuelveYaColors;
    case 'procord':
      return ProcordColors;
    case 'mifianza':
      return MifianzaColors;
    case 'fembisol':
      return FembisolColors;
    case 'inversiones':
      return InversionesColors;
    case 'zali':
      return ZaliColors;
    case 'libramoneda':
      return LibramonedaColors;
    case 'mili':
      return MiliColors2;
    case 'finnvo':
      return FinnvoColors;
    case 'bancaliv':
      return BancalivColors;
    case 'creditoo':
      return CreditooColors;
    case 'fie':
      return FieColors;
    case 'fibanca':
      return FibancaColors;
    case 'fondo':
      return FondoColors;
    case 'tusolucion':
      return TuSolucionColors;
    case 'credipress':
      return CredipressColors;
    case 'liberate':
      return LiberateColors;
    case 'nauw':
      return NauwColors;
    case 'lenddi':
      return LenddiColors;
    case 'gym':
      return GymColors;
    case 'credinver':
      return CredinverColors;
    case 'freend':
      return FreendColors;
    case 'maxcredit':
      return MaxcreditColors;
    case 'sofi':
      return SofiColors;
    case 'quickbank':
      return QuickBankColors;
    case 'finanzas':
      return FinanzasColors;
    case 'suvalor':
      return SuValorColors;
    case 'crecevalor':
      return CreceValorColors;
    case 'socialcredit':
      return SocialCreditColors;
    case 'cxc':
      return CxCColors;
    case 'banvi':
      return BanviColors;
    case 'trufi':
      return TrufiColors;
    case 'hazloya':
      return HazloyaColors;
    case 'pys':
      return PysColors;
    case 'netwifi':
      return NetWifiColors;
    case 'credyfast':
      return CredyfastColors;
    case 'valit':
      return ValitColors;
    case 'finanz':
      return FinanzColors;
    case 'logicash':
      return LogicashColors;
    case 'krennova':
      return KrennovaColors;
    default:
      return MiliColors2;
  }
};

const colorMainLocalStorage = window.localStorage.getItem('colorsTheme');

const options: any = {
  palette: colorMainLocalStorage ? JSON.parse(colorMainLocalStorage) : selectTheme(),
};

const theme = createTheme(options);

export default theme;
